import {publishLast, refCount, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import * as _ from 'lodash';


@Injectable()
export class HttpService {

    constructor(private http: HttpClient) {
    }

    toHttpParams(params: object): HttpParams {

        let httpParams = new HttpParams();
        _.forOwn(params || {}, (value: string | number | boolean, key: string) => {
            httpParams = httpParams.set(key, value);
        });
        return httpParams;
    }

    get<T>(url: string, queryParams?: object): Observable<T> {

        const options = {
            params: this.toHttpParams(queryParams || {})
        };

        const req = this.http.get<T>(url, options)
            .pipe(
                tap(() => console.log('[GET] ' + url)),
                publishLast(), refCount());
        return req;
    }

    post<T>(url: string, payload: any): Observable<T> {
        return this.http.post(url, payload) as Observable<T>;
    }
}
